export const setAuthData = (data) => {
    console.log('access data' , data)
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('userDetails', JSON.stringify(data.user));
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('onBoardingPageCompletion', data.profile_completion);
};